namespace Matrix.Data {
    export interface SecurityMergeListRequest extends Serenity.ListRequest {
        RepairSecurityId?: number;
        RepairSourceCode?: string;
    }
}
